import { useContext } from 'react';
import { AppContext } from '../../context/appContext';

/**
 * @param {string} key Bodega for which we need translations
 * @param {string} defaultValue default value used when requested key is not available in translations
 * @returns {string} bodega translated value or default value
 */
const useBodega = (key, defaultValue) => {
  const [data] = useContext(AppContext);
  return data?.translations?.[key] || defaultValue;
};

export default useBodega;
